import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M9 11.25a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9m-6.75 3.938C3.612 12.834 6.086 11.25 9 11.25s5.388 1.584 6.75 3.938" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h18v18H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }